import { createStore } from "vuex";
import Token from "./utilities/jwt/Token.js";

export default createStore({
  state() {
    return {
      userLogged: null,
      views: {
        registro: {
          dialogForm: false,
        },
        unidade: {
          dialogForm: false,
        },
        setores: {
          dialogForm: false,
        },
        tipo: {
          dialogForm: false,
        },
        login: {
          dialogCreate: false,
          dialogFoggetPassword: false,
        },
        users: {
          dialogForm: false,
          dialogChangePassword: false,
        },
        groups: {
          dialogForm: false,
        },
      },
    };
  },
  getters: {
    getUserLogged(state) {
      return state.userLogged;
    },
  },
  mutations: {
    setUserLogged(state, token) {
      token = [
        {
          id: token.code,
          nome: token.name,
          services: token.services,
          email: token.user_name,
          authorities: token.authorities,
        },
      ];
      state.userLogged = token[0];
    },
  },
  actions: {
    setUserLogged({ commit }) {
      commit("setUserLogged", new Token().decodeToken('access_token'));
    },
  },
});